module.exports = __webpack_public_path__ + "img/3.9a6a41b9.jpg";